import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { RoiService } from '@smartflip/ui-utils';
import { FieldConfig } from '@smartflip/data-models';
import { acquisitionFields } from '@smartflip/data-field-configuration';
import { subCategoryMap } from './acquisition-costs.constants';

@Component({
  selector: 'app-acquisition-costs',
  templateUrl: './acquisition-costs.component.html',
  styleUrls: ['./acquisition-costs.component.scss'],
  standalone: false,
})
export class AcquisitionCostsComponent implements OnInit {
  public total: number;
  public acquisitionForm: UntypedFormGroup;
  public fieldList: FieldConfig[];
  private currentCategory = '';

  constructor(private roi: RoiService) {}

  public isSubtotalRow(fieldName: string): boolean {
    return fieldName.includes('subtotal');
  }

  public newCategory(category: string | undefined): boolean {
    if (this.currentCategory !== category) {
      this.currentCategory = category;

      return true;
    }

    return false;
  }

  public getSubtotalLabel(subCategory: string): string {
    return subCategoryMap[subCategory] || '';
  }

  ngOnInit() {
    this.total = 0;
    this.acquisitionForm = this.roi.formGroups['acq'];
    this.fieldList = acquisitionFields;
  }
}
